// 将指定类型T, 递归可选
export type RecursivePartial<T> = {
  [P in keyof T]?: T[P] extends (infer U)[]
    ? RecursivePartial<U>[]
    : T[P] extends object
      ? RecursivePartial<T[P]>
      : T[P]
}

export enum Status {
  DISABLE = 'DISABLED',
  ENABLE = 'ACTIVE',
}

export enum StatusText {
  DISABLE = 'disable',
  ENABLE = 'enable',
}

export enum Role {
  USER = 'USER',
  SUPER = 'SUPER',
  ADMIN = 'ADMIN',
}

export type UpdateStatus = {
  id: number
  status: Status
}

export type DataSearch = {
  page: number
  pageSize: number
  query?: string
}

export enum Direction {
  ASC = 'asc',
  DESC = 'desc',
}

export type SortConfig = {
  key: string | null
  direction: Direction | null
}
